/*
 * @Author: Ryan
 * @Date: 2025-12-02
 * @Description: SEO sections entry file for video-translator page
 */
import React from 'react';

// import Footer from '@/components/Footer';
import { ComparisonSection } from './ComparisonSection';
import ExploreToolsSection from './ExploreToolsSection';
import FAQSection from './FAQSection';
import HeroSection from './HeroSection';
import HowToTranslateSection from './HowToTranslateSection';
import LanguageSection from './LanguageSection';
import PowerfulFeaturesSection from './PowerfulFeaturesSection';
import TestimonialsSection from './TestimonialsSection';
import TrustSection from './TrustSection';
import UseCasesSection from './UseCasesSection';
import VideoShowcaseSection from './VideoShowcaseSection';
import VideoTranslatorHiddenSEO from './VideoTranslatorHiddenSEO';
import WhyChooseSection from './WhyChooseSection';

const SEOSections: React.FC = () => {
  return (
    <>
      {/* 隐藏的 SEO 内容 - 供爬虫抓取首屏视频播放器的内容 */}
      <VideoTranslatorHiddenSEO />
      {/* <TrustSection /> */}
      <LanguageSection />
      <VideoShowcaseSection />
      <HowToTranslateSection />
      <PowerfulFeaturesSection />
      <UseCasesSection />
      <WhyChooseSection />
      <ComparisonSection />
      <TestimonialsSection />
      <ExploreToolsSection />
      <FAQSection />
      <HeroSection />
      {/* <Footer /> */}
    </>
  );
};

export default SEOSections;

// 也导出单独的组件,方便按需引入
export {
  ComparisonSection,
  ExploreToolsSection,
  FAQSection,
  HeroSection,
  HowToTranslateSection,
  LanguageSection,
  PowerfulFeaturesSection,
  TestimonialsSection,
  TrustSection,
  UseCasesSection,
  VideoShowcaseSection,
  WhyChooseSection,
};
export { default as StartButton } from './StartButton';
